import React from "react";

// import Poly1 from "../../../../assets/img/Polygon1.svg";
// import Poly2 from "../../../../assets/img/Polygon2.svg";
// import Poly3 from "../../../../assets/img/Polygon3.svg";

import "./hero.styles.scss";
import hero from "assets/img/hero.png";

const HeroSection = () => {
  return (
    <div className="hero-section">
      <div className="container">
        {/* <img src={Poly1} className="poly1" alt="polygon1"></img> */}
        <div className="row">
          <div className="col-lg-6 d-flex align-items-end">
            <div className="hero-section_description">
              <h1>
                Inspired
                {/* <img src={Poly3} className="poly3" alt="polygon2"></img> */}
                <br />
                to be <span>better</span>
              </h1>
              <p className="mt-5">
                A transforming force in the digital realm, igniting growth and
                propelling businesses to new heights with unrivaled expertise.
              </p>

              <div className="hero-section_button mt-5 mb-3">
                <button className="btn btn-lg btn-rounded btn-outline-primary mr-3">
                  Let&apos;s Talk
                </button>

                <button className="btn btn-lg btn-rounded btn-primary">
                  Our Services
                </button>
                {/* <img src={Poly2} className="poly2" alt="polygon2"></img> */}
              </div>
            </div>
          </div>
          <div className="col-lg-6 hero-section_image">
            <img src={hero} alt="brandspire-hero" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
